import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import CreatePage from "./components/pages/Create";
import EditPage from "./components/pages/Edit";
import HomePage from "./components/pages/Home";
// import Footer from "./components/Footer";
// import Navigation from "./components/Navigation";
// import Add from "./components/pages/Add";
// import Edit from "./components/pages/Edit";
// import Home from "./components/pages/Home";
// import Video from "./components/pages/Video";

function App() {
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/" element={<HomePage />} />
                {/* <Route path="/videos/:videoId" element={<Video />} /> */}
                <Route path="/books/create" element={<CreatePage />} />
                <Route path="/books/edit/:bookId" element={<EditPage />} />
            </Routes>
            {/* <Footer /> */}
        </Router>
    );
}

export default App;
